export default "__VITE_ASSET__324e75ae__"